export class ProjectMailingDocumentCopyDetailedDTO {
  mailingDocumentCopyId: number;
  mailingDocumentId: number;
  actionType: string;
  copies: string;
  date: Date;
  comment: string;
}
